import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-vertical-stud-system-inputs',
    templateUrl: './vertical-stud-system-inputs.component.html',
    styleUrls: ['./vertical-stud-system-inputs.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class VerticalStudSystemInputsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  readonly unitTypeChanged = output<void>();
  readonly systemTypeChanged = output<void>();
  unitTypeSelection!: GuruEntity;
  unitSizeSelection!: GuruEntity;
  systemTypeSelection!: GuruEntity;
  coilRowsSelection!: GuruEntity;
  airFilterSelection!: GuruEntity;
  unitVoltageSelection!: GuruEntity;
  motorTypeSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.unitTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnit');
    this.unitSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
    this.systemTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSystemType');
    this.coilRowsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCoilRows');
    this.airFilterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitVoltage');
    this.motorTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMotorType');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  unitChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.unitTypeChanged.emit());
  }

  systemChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.systemTypeChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
